import React from "react";
import normalize from "app/utils/normalize";

import SkeletonContent from "react-native-skeleton-content-nonexpo";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const firstLayout = [
  {
    flexDirection: "column",
    marginRight: normalize(20),
    children: [
      {
        width: normalize(40),
        height: normalize(40),
        borderRadius: normalize(20),
        marginTop: normalize(5),
      },
      {
        height: "90%",
        width: normalize(3),
        marginLeft: normalize(18),
        marginTop: normalize(5),
      },
    ],
  },
  {
    flexDirection: "column",
    marginRight: normalize(10),
    width: "100%",
    children: [
      {
        width: "80%",
        height: normalize(15),
        marginTop: normalize(20),
        marginBottom: normalize(20),
      },
      {
        width: "80%",
        height: "80%",
        marginBottom: normalize(10),
      },
      {
        marginTop: normalize(10),
        flexDirection: "row",
        width: "80%",
        children: [
          {
            width: normalize(25),
            height: normalize(25),
            borderRadius: normalize(15),
            marginRight: normalize(10),
          },
          {
            width: "80%",
            height: normalize(6),
            marginTop: normalize(10),
            marginBottom: normalize(20),
          },
        ],
      },
    ],
  },
];

interface Props {
  children: JSX.Element;
  isLoading: boolean;
}

const CommentSkeleton = ({ children, isLoading }: Props) => {
  if (isWebDesktop) {
    return children;
  }

  return (
    <SkeletonContent
      isLoading={isLoading}
      layout={firstLayout}
      containerStyle={{
        display: "flex",
        flexDirection: "row",
        flex: 1,
        width: "100%",
      }}
    >
      {children}
    </SkeletonContent>
  );
};

export default CommentSkeleton;
